// client/src/services/siteApi.js
import api from "./api";

export async function fetchPublicContact() {
  const { data } = await api.get("/public/contact");
  return data?.contact ?? null;
}

export async function updatePublicContact(payload) {
  // requires admin login cookie
  const { data } = await api.put("/admin/contact", payload, {
    withCredentials: true,
  });
  return data; // { message, contact }
}
